function directive($timeout) {
    return {
        restrict: 'A',
        template : require('../../views/sevButtons.html'),
        transclude : false,
        link: function ($scope, element, attrs) {
            var dimension, group, outFilter, hHeight, cid = false, key, uid, searchCategories, div = "#sevButtons"; // because there is one instances of this directive per view, we can assign a uid directly to it
            var sevHeights;

            var dictionary = { 'guarded': '0' , 'guarded': '1' , 'elevated': '2', 'high': '3', 'severe': '4' };
            var dictionary2 = { 0: 'guarded', 1: 'guarded', 2: 'elevated', 3: 'high', 4: 'severe' };
            var activeFilters = {};
            // $scope.data.dc = {};
            $scope.severityLevels = {}
            $scope.clicked = function (type) {
                var column, title;
                for (let s in searchCategories) {
                    column = s;
                    title = searchCategories[s];
                    break;
                }
                $scope.main.filterItem(column, dictionary[type], "include", title);
            };

            $scope.$on('init', function (event, chart) {
                if (chart.id !== attrs.uid) { return }
                if (typeof $scope.main.dataObjects[chart.key] === 'undefined') { return } // if its not in our dc object, ignore
                $scope.main.dataObjects[chart.key].launched = true;
                uid = chart.id;
                cid = uid
                key = chart.key;

                dimension = $scope.main.dataObjects[key].dimension;
                group = $scope.main.dataObjects[key].group;
                searchCategories = $scope.main.dataObjects[key].settings.searchCategories;
                if (typeof setHeight === "undefined") {
                    setUpData()
                    makeButtonHeights(uid);
                    iconSetup();
                }
            });

            function setUpData() {
                $scope.severityLevels.levels = {
                    guarded: {
                        value: 0,
                        active: true
                    },
                    elevated: {
                        value: 0,
                        active: true
                    },
                    high: {
                        value: 0,
                        active: true
                    },
                    severe: {
                        value: 0,
                        active: true
                    }
                }
                var data = group.top(Infinity);
                for (var i = 0, len = data.length; i < len; i++) {
                    if (typeof $scope.severityLevels.levels[dictionary2[data[i].value.severity]] !== "undefined") {
                        $scope.severityLevels.levels[dictionary2[data[i].value.severity]].value += data[i].value.count;
                    }
                }
                // disable the buttons with 0
                for (var i in  $scope.severityLevels.levels) {
                    if (($scope.severityLevels.levels[i].value === 0) || ($scope.severityLevels.levels[i].value === "")) {
                        $scope.severityLevels.levels[i].active = false;
                    }
                }
            }

            function makeButtonHeights(uid) {
                // if (typeof $scope.data.dc[uid].visuals.rowchart === 'undefined') { return }
                sevHeights = [0,0,0,0];

                var count = 0,val;
                group.top(Infinity).filter(function (d) {
                    val = d.key.slice(d.key.length-1, d.key.length)-1;
                    if (((d.key.slice(d.key.length-1, d.key.length) === "0") || (d.key.slice(d.key.length-1, d.key.length) === 0)) && (val > 0))  {
                        val = d.key.slice(d.key.length-1, d.key.length)
                    }
                    count++;
                    sevHeights[val]++;
                });

                if (count < 7) {
                    hHeight = 33;
                } else {
                    hHeight = 29;
                }
                d3.select("#severityButtons").style("margin","8px 0px 0px 0px")
                for (var i = 0; i < sevHeights.length; i++) {
                    if (sevHeights[i] === 0) {
                        d3.select('.alert'+(i+1)).style("display", "none");
                    } else {
                        d3.select('.alert'+(i+1)).style("display", "block");
                        d3.select('.alert'+(i+1)).style("height",((sevHeights[i]*hHeight)-5)+"px");
                    }
                }
            }

            function iconSetup() {
                d3.select('.alert1').selectAll('svg').remove();
                d3.select('.alert2').selectAll('svg').remove();
                d3.select('.alert3').selectAll('svg').remove();
                d3.select('.alert4').selectAll('svg').remove();

                d3.select('.alert1 .severitySvg2015').insert('svg')
                    .attr('width', 20)
                    .attr('height', 20)
                    .append('polygon')
                       .attr("class", "userColor")
                       .attr('points', '9,1 8,0 0,0 0,18 2,18 2,10 7,10 8,11 14,11 14,1 ')
                       .style('fill', '#333');

                d3.select('.alert2 .severitySvg2015').insert('svg')
                    .attr('width', 20)
                    .attr('height', 20).append('polygon')
                       .attr("class", "userColor")
                       .attr('points', '3.6,0 3.6,2 12.4,2 0,14.4 1.4,15.8 13.6,3.6 13.6,12 15.6,12 15.6,0 ')
                       .style('fill', '#333');

                d3.select('.alert3 .severitySvg2015').insert('svg')
                    .attr('width', 20)
                    .attr('height', 20).append('path')
                       .attr("class", "userColor")
                       .attr('d', 'M17.7,17H0c0.5-1.3,1.3-2.5,2.3-3.4V8h0c0.2-2.9,2.3-5.3,5.1-5.9C7.4,1.9,7.3,1.7,7.3,1.5C7.3,0.7,8,0,8.8,0'+
                       's1.5,0.7,1.5,1.5c0,0.2-0.1,0.4-0.2,0.6c2.8,0.6,4.9,3,5.1,5.9h0v5.6C16.3,14.5,17.1,15.7,17.7,17z M8.8,20c1.2,0,2.2-0.9,2.4-2H6.4'+
                       'C6.6,19.1,7.6,20,8.8,20z')
                       .style('fill', '#333');

                d3.select('.alert4 .severitySvg2015').insert('svg')
                    .attr('width', 20)
                    .attr('height', 20)
                    .append('path')
                       .attr("class", "userColor")
                       .attr('d', 'M12.7,0H5.3L0,5.3v7.5L5.3,18h7.5l5.3-5.3V5.3L12.7,0z M10,14H8v-2h2V14z M10,10H8V4h2V10z')
                       .style('fill', '#333')
            }

            // set update functions
            $scope.$on('updatedData', function (event, id, filteredOn) {
                if (id !== uid) { return } // only run when it sees its id has filtered
                setUpData();
                makeButtonHeights(uid);
                iconSetup();
            });
            $scope.$on('$destroy', function () {
                // $timeout.cancel(iconTimeout);
                element.remove();
            });
        }
    };
}

directive.$inject = ['$timeout'];
module.exports = directive;


/** WEBPACK FOOTER **
 ** ./src/pages/directives/severitylevels/severitylevels.js
 **/